import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { TextSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import specialContractsPng from '/img/lottery/special-contracts.png';
import specialContractsWebp from '/img/lottery/special-contracts.webp';
import spinRewardsPng from '/img/lottery/spin-rewards.png';
import spinRewardsWebp from '/img/lottery/spin-rewards.webp';
import weeklyArenaPng from '/img/lottery/weekly-arena.png';
import weeklyArenaWebp from '/img/lottery/weekly-arena.webp';

const TicketsPlaces: FC = () => {
  const { t } = useTranslation();

  const config = [
    {
      picture: {
        img: spinRewardsPng,
        webp: spinRewardsWebp,
        alt: 'Daily Goods',
      },
      label: 'Daily Goods',
      to: `${AppRoute.MAIN}?initialTab=daily`,
    },
    {
      picture: {
        img: specialContractsPng,
        webp: specialContractsWebp,
        alt: 'Special Contracts',
      },
      label: 'Special Contracts',
      to: `${AppRoute.MAIN}?initialTab=special`,
    },
    {
      picture: {
        img: weeklyArenaPng,
        webp: weeklyArenaWebp,
        alt: 'Weekly Arena',
      },
      label: 'Weekly Arena',
      to: AppRoute.LEAGUES,
    },
  ];

  return (
    <div className="flex w-full gap-4 px-[1.125rem] items-center justify-center mb-6 md-h:mb-4 720-h:!mb-2">
      {config.map(({ picture, label, to }) => (
        <Link
          key={label}
          to={to}
          className="flex flex-1 max-w-[118px] flex-col justify-center items-center gap-1"
        >
          <Picture {...picture} className="size-20 shrink-0" />
          <TextSmall className="!leading-1.2 [word-spacing:50px] text-center">
            {t(label)}
          </TextSmall>
        </Link>
      ))}
    </div>
  );
};

export { TicketsPlaces };
